import React from 'react';
import styled from 'styled-components';
import WebTitle from './../../images/WebTitle.png';

const NameLogo = () => {
  return <Image src={WebTitle} alt="Naya Yougbodh National Daily" />;
};

const Image = styled.img`
  height: 100%;

  @media (max-width: 340px) {
    width: 70vw;
    height: auto;
    align-self: center;
  }
`;

// const Title = styled.h1`
//   color: #c20e1a;
// `;

export default NameLogo;
